<div [ngClass]="isMobile ? 'mobile-header' : 'header'">
  <app-external-header
    style="z-index: 1000; position: relative;"
    [isInboxPresent]="false"
    [isCompanyProfile]="false"
    [isAgencyProfile]="false"
    [isProfile]="false"
    [isMobile]="isMobile"
    [showButtons]="false"
    [showProfilePicture]="false">
  </app-external-header>
</div>

<div class="container">
  <mat-sidenav-container class="layout-container">
    <mat-sidenav
      class="sidenav"
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="!isMobile"
      disableClose>
      <mat-nav-list>
        <button mat-list-item (click)="select('dashboard')" >
          <mat-icon>dashboard</mat-icon> &nbsp;
          <span>Dashboard</span>
        </button>

        <button mat-list-item (click)="select('users')" >
          <mat-icon>group</mat-icon> &nbsp;
          <span>Users</span>
        </button>

        <button mat-list-item (click)="select('companies')">
          <mat-icon>apartment</mat-icon> &nbsp;
          <span>Companies</span>
        </button>

        <button mat-list-item (click)="select('consultations')">
          <mat-icon>event_available</mat-icon> &nbsp;
          <span>Consultations</span>
        </button>

        <button mat-list-item (click)="select('slots')">
          <mat-icon>schedule</mat-icon> &nbsp;
          <span>Slots</span>
        </button>

        <button mat-list-item (click)="select('emails')">
          <mat-icon>mail</mat-icon> &nbsp;
          <span>Emails</span>
        </button>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <main class="page-content">
        <ng-container [ngSwitch]="selectedView">
          <app-dashboard-page *ngSwitchCase="'dashboard'"></app-dashboard-page>
          <app-user-page *ngSwitchCase="'users'"></app-user-page>
          <app-company-page *ngSwitchCase="'companies'"></app-company-page>
          <app-consultation-admin-page *ngSwitchCase="'consultations'"></app-consultation-admin-page>
          <app-slot-admin-page *ngSwitchCase="'slots'"></app-slot-admin-page>
          <app-broadcast-email-page *ngSwitchCase="'emails'"></app-broadcast-email-page>
        </ng-container>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
